const key = 'luvsosa-search-history';
function read() { try { return JSON.parse(localStorage.getItem(key) || '[]').filter(q => typeof q === 'string').slice(0, 8); } catch { return []; } }
function save(term) {
  term = term.trim().slice(0, 100);
  if (!term) return;
  try { localStorage.setItem(key, JSON.stringify([term, ...read().filter(q => q.toLowerCase() !== term.toLowerCase())].slice(0, 8))); } catch {}
}
class LsSearchHistory extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('click', event => {
      if (event.target.closest('[data-clear]')) {
        try { localStorage.removeItem(key); } catch {}
        document.querySelectorAll('ls-search-history').forEach(el => el.render());
      }
    }, { signal: this.abort.signal });
    this.render();
  }
  disconnectedCallback() { this.abort?.abort(); }
  render() {
    const terms = read();
    const links = this.querySelector('[data-history-links]');
    links.replaceChildren();
    this.hidden = !terms.length;
    for (const term of terms) {
      const a = document.createElement('a');
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('q', term);
      a.href = url.toString();
      a.textContent = term;
      links.append(a);
    }
  }
}
if (!customElements.get('ls-search-history')) {
  customElements.define('ls-search-history', LsSearchHistory);
  const remember = event => {
    const component = event.target.closest('predictive-search-component');
    const input = component?.querySelector('input[name="q"]');
    if (input) save(input.value);
  };
  document.addEventListener('submit', remember, true);
  document.addEventListener('keydown', event => { if (event.key === 'Enter') remember(event); }, true);
  document.addEventListener('click', event => { if (event.target.closest('predictive-search-component a')) remember(event); }, true);
}